import AsyncStorage from '@react-native-async-storage/async-storage';
import { TimeSlot, TimetableData } from '../types/timetable';

const TIMETABLE_KEY = '@timetable';

export class StorageService {
  static async saveTimetable(timetable: TimetableData): Promise<void> {
    try {
      await AsyncStorage.setItem(TIMETABLE_KEY, JSON.stringify(timetable));
    } catch (error) {
      console.error('Error saving timetable:', error);
      throw error;
    }
  }

  static async loadTimetable(): Promise<TimetableData | null> {
    try {
      const data = await AsyncStorage.getItem(TIMETABLE_KEY);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error('Error loading timetable:', error);
      throw error;
    }
  }

  static async addClass(day: string, classData: TimeSlot): Promise<void> {
    try {
      const timetable = await this.loadTimetable() || {};
      if (!timetable[day]) {
        timetable[day] = [];
      }
      timetable[day].push(classData);
      await this.saveTimetable(timetable);
    } catch (error) {
      console.error('Error adding class:', error);
      throw error;
    }
  }

  static async updateClass(day: string, classData: TimeSlot): Promise<void> {
    try {
      const timetable = await this.loadTimetable();
      if (!timetable || !timetable[day]) {
        throw new Error('Timetable or day not found');
      }
      const index = timetable[day].findIndex(c => c.id === classData.id);
      if (index === -1) {
        throw new Error('Class not found');
      }
      timetable[day][index] = classData;
      await this.saveTimetable(timetable);
    } catch (error) {
      console.error('Error updating class:', error);
      throw error;
    }
  }

  static async deleteClass(day: string, classId: string): Promise<void> {
    try {
      const timetable = await this.loadTimetable();
      if (!timetable || !timetable[day]) {
        throw new Error('Timetable or day not found');
      }
      timetable[day] = timetable[day].filter(c => c.id !== classId);
      await this.saveTimetable(timetable);
    } catch (error) {
      console.error('Error deleting class:', error);
      throw error;
    }
  }
}
